export const YEAR_DEFAULT: number = 2000;
export const PROGRESS_BAR_FULL: number = 100;
export const ONE_HUNDRED_RANK: number = 100;
export const FIVE_HUNDRED_RANK: number = 500;
export const ONE_THOUSAND_RANK: number = 1000;
export const FIVE_THOUSAND_RANK: number = 5000;
export const THIRTY_DAYS_CATEGORY: number = 30;
export const NINETY_DAYS_CATEGORY: number = 90;
export const THREE_MONTHS_CATEGORY: number = 3;
export const TWENTY_FOUR_MS: number = 24;
export const SIXTY_MS: number = 60;
export const ONE_THOUSAND_MS: number = 1000;
export const SLICE_THREE: number = 3;
export const SLICE_FIVE: number = 5;
